export default {
  sales: {
    labels: ["Apr", "May", "Jun"],
    datasets: {
      label: "My First Dataset",
      data: [300, 50, 100],
      hoverOffset: 4,
    },
  },
  tasks: {
    labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: { label: "Desktop apps", data: [50, 40, 300, 220, 500, 250, 400, 230, 500] },
  },
};
